export default __webpack_public_path__ + "static/media/ic_metamask_16.7b7f48c0.svg";